import { Phone } from "lucide-react";

// Sticky call control — bottom right, visually separate from the centered nav.
export const FloatingControls = () => (
  <a
    href="tel:+19704827676"
    data-testid="call-button"
    aria-label="Call PMP at (970) 482-7676"
    className="float-ctrl blue fixed bottom-[calc(0.9rem+env(safe-area-inset-bottom))] right-4 h-12 w-12 sm:right-6 sm:h-12 sm:w-auto sm:px-5"
  >
    <Phone className="h-5 w-5 shrink-0" />
    <span className="ml-2 hidden font-mono text-xs tracking-[0.08em] sm:inline">(970) 482-7676</span>
  </a>
);
